export default function MicrophoneSvg(props: { className?: string }) {
  const { className } = props
  return (
    <svg
      className={cls`${className}`}
      width='12'
      height='13'
      viewBox='0 0 12 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.25 2.0498C4.93796 2.0498 5.57646 2.26759 6.09863 2.6377C6.91535 3.21662 7.4502 4.17093 7.4502 5.25C7.4502 5.5143 7.41735 5.77093 7.35693 6.0166L9.479 8.66846C9.78301 9.04847 9.83824 9.55284 9.65771 9.97754C9.75426 10.0469 9.87245 10.0874 10 10.0874C10.1754 10.0874 10.3327 10.0108 10.4409 9.88818C10.5917 9.71766 10.8522 9.70146 11.0229 9.85205C11.1936 10.0027 11.21 10.2633 11.0596 10.4341C10.8014 10.7266 10.4219 10.9126 10 10.9126C9.66111 10.9126 9.35011 10.7928 9.10693 10.5942C8.65891 10.8476 8.08791 10.8146 7.66846 10.479L5.01611 8.35693C4.77058 8.41728 4.51414 8.4502 4.25 8.4502C3.1709 8.4502 2.21662 7.91538 1.6377 7.09863C1.26759 6.57646 1.0498 5.93796 1.0498 5.25C1.0498 3.48269 2.48269 2.0498 4.25 2.0498ZM6.95654 6.95605C6.70168 7.35951 6.35951 7.70168 5.95605 7.95654L8.23096 9.77637C8.38531 9.89975 8.60782 9.8873 8.74756 9.74756C8.88727 9.60782 8.89974 9.3853 8.77637 9.23096L6.95654 6.95605ZM6.06396 3.83594C5.51329 5.32874 4.32875 6.51331 2.83594 7.06396C3.22624 7.36872 3.71692 7.5498 4.25 7.5498C5.52026 7.5498 6.5498 6.52026 6.5498 5.25C6.5498 4.71692 6.36872 4.22624 6.06396 3.83594ZM4.25 2.9502C2.97975 2.9502 1.9502 3.97975 1.9502 5.25C1.9502 5.63755 2.04651 6.00145 2.21533 6.32129C3.71048 5.88931 4.88928 4.71047 5.32129 3.21533C5.00145 3.04651 4.63755 2.9502 4.25 2.9502Z'
        fill='#A0A0AA'
      />
    </svg>
  )
}
